<template>
    <div class="fixed md:hidden left-0 right-0 top-0 bottom-0 bg-[#0006] z-[1020]" v-if="!isCollapsed"  @click="closeLeftNavOnOverlay"></div>
    <div ref="sidebarRef"
        class="left-nav nav-custom flex flex-col bg-[#fff] shadow-sm fixed md:sticky !top-0 md:top-auto left-0 z-[1030] md:z-0"
        :class="isCollapsed ? 'hidden md:flex md:w-[80px]' : 'flex w-[280px]'"
        style="height: calc(100vh - var(--notification-height, 0px));">
        <!-- Logo & Collapse Button -->
        <div class="flex justify-between p-4 shrink-0">
            <a v-if="!isCollapsed" href="/dashboard">
                <img :src="`${MEDIA_ASSET_BASE_URL}${MEDIA_ASSET_LANDING_PATH}LogoHeader.svg`"
                    class="h-8 cursor-pointer" />
            </a>
            <button
                class="text-[#6E6E6E] border-2 border-[#D1D1D1] rounded w-8 focus:outline-none items-center justify-center"
                :class="isCollapsed ? 'hidden md:flex' : 'flex'" @click="toggleCollapse">
                <i class="text-xl"
                    :class="isCollapsed ? 'ri-arrow-right-double-fill' : 'ri-arrow-left-double-fill'"></i>
            </button>
        </div>
        <!-- Nav Links -->
        <nav ref="navRef" class="flex-1 text-base overflow-y-auto">

            <ul>
                <a v-for="item in filteredMenuItems" :key="item.menu" :href="item.link"
                    class="font-normal no-underline hover:no-underline">
                    <li class="text-[#464646] pb-1 relative" :class="[isCollapsed ? 'px-1' : 'px-3']">

                        <!-- Main Menu -->
                        <div @click="handleMenuClick(item, false, $event)"
                            class="menu-item-click cursor-pointer rounded transition-all px-2 py-1.5 flex items-center justify-between"
                            :class="[
                                isMenuItemActive(item) ? 'bg-[#F4EAEA] !text-[#762123] font-semibold' : 'hover:bg-[#EBEBEB] hover:text-[#171717]',
                                isCollapsed ? 'flex-col justify-center text-center gap-y-1' : 'gap-x-2'
                            ]">
                            <div class="flex" :class="isCollapsed ? 'flex-col' : 'gap-2 items-center'">
                                <i class="text-xl"
                                    :class="[activeMenu === item.menu ? item.selectedIcon : item.icon]"></i>
                                <span :class="isCollapsed ? 'leading-[10px] text-[10px]' : 'font-semibold'">{{
                                    t(item.name) }}</span>
                            </div>

                            <i v-if="item.submenu && !isCollapsed" :class="[
                                'transition-transform duration-200',
                                activeMenu === item.menu ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'
                            ]"></i>
                        </div>
                        <!-- Submenu -->
                        <transition name="fade">
                            <!-- Normal screens -->
                            <ul v-if="activeMenu === item.menu && item.submenu && !isCollapsed"
                                class="text-[#464646] space-y-1.5 pt-1.5">
                                <a v-for="sub in item.submenu" :key="sub.menu" :href="sub.link"
                                    class="text-[#464646] font-normal no-underline hover:no-underline">
                                    <li @click="handleMenuClick(sub, true, $event)"
                                        class="flex items-center p-1 rounded cursor-pointer space-x-2" :class="[
                                            activeSubMenu === sub.menu
                                                ? 'bg-[#F4EAEA] !text-[#762123] font-semibold'
                                                : 'hover:bg-[#EBEBEB] hover:text-[#171717]'
                                        ]">
                                        <i v-if="!isCollapsed" :class="sub.icon" class="pl-4"></i>
                                        <span>{{ t(sub.name) }}</span>
                                    </li>
                                </a>
                            </ul>

                            <!-- Large screens -->
                            <ul v-else-if="largeScreenPopoverOpen && activeMenu === item.menu && item.submenu && isLargeScreen && isCollapsed"
                                class="absolute left-full top-0 bg-[#fff] border shadow-md w-[280px] px-3 py-2 text-sm text-[#464646] space-y-1.5 !z-[9999] min-w-[200px]">
                                <a v-for="sub in item.submenu" :key="sub.menu" :href="sub.link"
                                    @click="handleMenuClick(sub, true, $event)" class="no-underline hover:no-underline">
                                    <li class="text-[#464646] font-normal no-underline hover:no-underline flex items-center space-x-2 p-2 rounded text-[#464646] cursor-pointer"
                                        :class="[activeSubMenu === sub.menu ? 'bg-[#F4EAEA] !text-[#762123] font-semibold' : 'hover:bg-[#EBEBEB] hover:text-[#171717]']">
                                        <span>{{ t(sub.name) }}</span>
                                    </li>
                                </a>
                            </ul>
                        </transition>
                    </li>
                </a>
                <div :class="isCollapsed ? 'px-1' : 'px-3'">
                    <div class="w-full border-t-2  pt-2 pb-2 border-[#D1D1D1] ">
                        <span
                            class="font-medium text-[12px] leading-[120%] tracking-[0.05em] uppercase">Tools</span>
                    </div>
                </div>

                <!-- Tool Menu Items -->
                <a v-for="item in filteredToolMenuItems" :key="item.menu" :href="item.link"
                    class="font-normal no-underline hover:no-underline ">
                    <li class="text-[#464646] pb-1 relative" :class="[isCollapsed ? 'px-1' : 'px-3']">

                        <!-- Main Menu -->
                        <div @click="handleMenuClick(item, false, $event)"
                            class="menu-item-click cursor-pointer rounded transition-all px-2 py-1.5 flex items-center justify-between"
                            :class="[
                                isMenuItemActive(item) ? 'bg-[#F4EAEA] !text-[#762123] font-semibold' : 'hover:bg-[#EBEBEB] hover:text-[#171717]',
                                isCollapsed ? 'flex-col justify-center text-center gap-y-1' : 'gap-x-2'
                            ]">
                            <div class="flex" :class="isCollapsed ? 'flex-col' : 'gap-2 items-center'">
                                <i class="text-xl"
                                    :class="[activeMenu === item.menu ? item.selectedIcon : item.icon]"></i>
                                <span :class="isCollapsed ? 'leading-[10px] text-[10px]' : 'font-semibold'">{{
                                    t(item.name) }}</span>
                            </div>

                            <i v-if="item.submenu && !isCollapsed" :class="[
                                'transition-transform duration-200',
                                activeMenu === item.menu ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'
                            ]"></i>
                        </div>
                        <!-- Submenu -->
                        <transition name="fade">
                            <!-- Normal screens -->
                            <ul v-if="activeMenu === item.menu && item.submenu && !isCollapsed"
                                class="text-[#464646] space-y-1.5 pt-1.5">
                                <a v-for="sub in item.submenu" :key="sub.menu" :href="sub.link"
                                    class="text-[#464646] font-normal no-underline hover:no-underline">
                                    <li @click="handleMenuClick(sub, true, $event)"
                                        class="flex items-center p-1 rounded cursor-pointer space-x-2" :class="[
                                            activeSubMenu === sub.menu
                                                ? 'bg-[#F4EAEA] !text-[#762123] font-semibold'
                                                : 'hover:bg-[#EBEBEB] hover:text-[#171717]'
                                        ]">
                                        <i v-if="!isCollapsed" :class="sub.icon" class="pl-4"></i>
                                        <span>{{ t(sub.name) }}</span>
                                    </li>
                                </a>
                            </ul>

                            <!-- Large screens -->
                            <ul v-else-if="largeScreenPopoverOpen && activeMenu === item.menu && item.submenu && isLargeScreen && isCollapsed"
                                class="absolute left-full top-0 bg-[#fff] border shadow-md w-[280px] px-3 py-2 text-sm text-[#464646] space-y-1.5 !z-[9999] min-w-[200px]">
                                <a v-for="sub in item.submenu" :key="sub.menu" :href="sub.link"
                                    @click="handleMenuClick(sub, true, $event)" class="no-underline hover:no-underline">
                                    <li class="text-[#464646] font-normal no-underline hover:no-underline flex items-center space-x-2 p-2 rounded text-[#464646] cursor-pointer"
                                        :class="[activeSubMenu === sub.menu ? 'bg-[#F4EAEA] !text-[#762123] font-semibold' : 'hover:bg-[#EBEBEB] hover:text-[#171717]']">
                                        <span>{{ t(sub.name) }}</span>
                                    </li>
                                </a>
                            </ul>
                        </transition>
                    </li>
                </a>
            </ul>

            <!-- POPOVER -->
            <Teleport to="body">
                <div v-if="isCollapsed && menuPopover.isOpen.value && popoverMenuData && popoverMenuData.submenu"
                    class="popover-area fixed bg-[#fff] border shadow-md w-[280px] px-3 py-2 text-sm !z-[9999] min-w-[200px]"
                    :style="{ top: menuPopover.position.value.top + 'px', left: menuPopover.position.value.left + 'px' }">
                    <ul class="space-y-2">
                        <a v-for="sub in popoverMenuData.submenu" :key="sub.menu" :href="sub.link"
                            @click="handleMenuClick(sub, true)" class="no-underline hover:no-underline">
                            <li class="text-[#464646] font-normal no-underline hover:no-underline flex items-center space-x-2 p-2 rounded text-[#464646] cursor-pointer"
                                :class="[activeSubMenu === sub.menu ? 'bg-[#F4EAEA] !text-[#762123] font-semibold' : 'hover:bg-[#EBEBEB] hover:text-[#171717]']">

                                <span>{{ t(sub.name) }}</span>

                            </li>
                        </a>
                    </ul>
                </div>
            </Teleport>

            <!-- PROFILE POPOVER -->
            <Teleport to="body">
                <div v-if="isCollapsed && profilePopover.isOpen.value"
                    class="popover-area fixed bg-[#fff] border shadow-md w-[280px] px-3 py-2 text-sm z-[99999] min-w-[200px]"
                    :style="{ top: profilePopover.position.value.top + 'px', left: profilePopover.position.value.left + 'px', zIndex: 99999 }">
                    <ul class="space-y-2">
                        <a v-for="item in filteredUserProfile" :key="item.menu" :href="item.link"
                            @click="handleMenuClick(item)" class="no-underline hover:no-underline">
                            <li class="text-[#464646] font-normal no-underline hover:no-underline flex items-center space-x-2 p-2 rounded cursor-pointer text-[#464646]"
                                :class="[activeMenu === item.menu ? 'bg-[#F4EAEA] !text-[#762123] font-semibold' : 'hover:bg-[#EBEBEB] hover:text-[#171717]']">

                                <span>{{ t(item.name) }}</span>

                            </li>
                        </a>
                    </ul>
                </div>
            </Teleport>
        </nav>

        <!-- Footer -->
        <div class="mt-10 text-[#464646] shrink-0" :class="isCollapsed ? 'px-1' : 'px-3'">

            <hr class="my-1" />
            <!-- Tabs -->
            <div v-if="!isCollapsed && internalUser"
                 class="flex items-center pl-3 ml-4 mt-2 bg-[#EBEBEB] rounded-full p-1 text-sm w-[164px] h-8">
                <button v-for="tab in ['internal', 'external']" :key="tab"
                        class="flex-1 text-center rounded-full bg-[#EBEBEB] capitalize w-[73px] h-[22px] focus:outline-none"
                        :class="activeTab === tab ? 'bg-[#fff] text-[#000000] font-bold' : 'text-[#6E6E6E]'"
                        @click="handleActiveTab(tab)">
                    {{ tab }}
                </button>
            </div>

            <!-- Profile -->
            <div class="mb-2 mt-2 relative">
                <div @click="toggleProfileSettings($event)"
                     class="flex items-center justify-between text-sm rounded cursor-pointer profile-area-trigger" :class="[
                            activeMenu === 'profile'
                                ? 'bg-[#F4EAEA]'
                                : 'hover:bg-[#EBEBEB] hover:text-[#171717]',
                            isCollapsed ? 'px-[18px] py-2' : 'p-2'
                        ]">
                    <div class="flex items-center space-x-2" :class="isCollapsed ? 'flex-col space-x-0 gap-1' : ''">
                        <div class="profile-avatar bg-[#8B8B8B] text-[#fff] rounded-md w-9 h-9 flex items-center justify-center text-sm">
                            {{ initials }}
                        </div>
                        <div v-if="!isCollapsed">
                            <p>{{ fullName }}</p>
                            <p class="font-semibold text-xs w-[170px] text-ellipsis overflow-hidden">{{ email }}</p>
                            <p v-if="accountNumber" class="text-xs text-[#6E6E6E] w-[170px] text-ellipsis overflow-hidden" :title="customerName || accountNumber">{{ accountNumber }}</p>
                        </div>
                        <p v-else-if="accountNumber && isCollapsed" class="text-xs text-[#464646] m-0 max-w-[64px] truncate" :title="customerName || accountNumber">{{ accountNumber }}</p>
                    </div>
                    <i v-if="!isCollapsed" :class="showProfileSettings ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'"
                       class="text-[#464646]"></i>
                </div>

                <!-- Profile Settings -->
                <transition name="fade">
                    <ul v-if="showProfileSettings && !isCollapsed" class="text-[#464646] text-base ml-4">
                        <a v-for="item in filteredUserProfile" :key="item.menu" :href="item.link"
                           @click="handleMenuClick(item)"
                           class="text-[#464646] font-normal no-underline hover:no-underline">
                        <li class="flex items-center space-x-2 p-2 cursor-pointer rounded mt-1"
                            :class="[
                        activeMenu === item.menu ? 'bg-[#F4EAEA] !text-[#762123] font-semibold' : 'hover:bg-[#EBEBEB] hover:text-[#171717]']">
                            <i :class="item.icon"></i>
                            <span>{{ t(item.name) }}</span>
                        </li>
                        </a>
                    </ul>
                </transition>
            </div>
        </div>
    </div>
</template>

<script setup>
import { MEDIA_ASSET_BASE_URL, MEDIA_ASSET_LANDING_PATH } from "@/config/constants.js";
import { computed, ref, onMounted, inject, watch, onUnmounted } from "vue";
import { menuItems, userProfile, toolMenuItems } from "@/utilities/menuItems";
import { useGlobalStore } from "@/stores/globalStore";
import { useI18n } from 'vue-i18n'
import { getToken, getLanguage } from '@/utilities/cookies';
import { usePopover } from "@/composables/usePopover";
import { useUserStore } from '@/stores/userStore'
const userStore = useUserStore();

const { t, locale } = useI18n()
locale.value = getLanguage();
const globalStore = useGlobalStore();

const activeMenu = ref("");
const activeSubMenu = ref("");
const isCollapsed = computed(() => globalStore.isLeftNavCollapsed)
const showProfileSettings = ref(false);
const activeTab = ref("external");
const customer = computed(() => userStore.userDetails)
const customerName = computed(() => customer.value?.CustomerDetail?.CustomerName ?? "")
const accountNumber = computed(() => customer.value?.CustomerDetail?.CustomerCode ?? "")
const firstName = computed(() => customer.value?.FirstName ?? "")
const lastName = computed(() => customer.value?.LastName ?? "")
const email = computed(() => customer.value?.Email ?? "")

const menuPopover = usePopover(80, 'menu-item-click');
const profilePopover = usePopover(80, 'profile-area-trigger');
const popoverMenuData = ref(null);
const sidebarRef = ref(null);
const navRef = ref(null);

const largeScreenPopoverOpen = ref(false);

const config = inject('config');

const windowWidth = ref(window.innerWidth)
const windowHeight = ref(window.innerHeight);

const isLargeScreen = computed(() => windowWidth.value >= 1920)

const handleResize = () => {
    windowWidth.value = window.innerWidth;
};
const isMenuItemActive = (item) => {
    if (isCollapsed.value) {
        // When collapsed , only main menu is highlighted
        return activeMenu.value === item.menu;
    }
    if (item.submenu?.some((sub) => sub.menu === activeSubMenu.value)) {
        // When submenu is highlighed , main menu should not be highlighted
        return false;
    }
    return activeMenu.value === item.menu;
};

const closeAllPopovers = (e) => {
    const clickedInsidePopover = e.target.closest(".popover-area");
    const clickedOnMenuItem = e.target.closest(".menu-item-click");

    if (!clickedInsidePopover && !clickedOnMenuItem) {
        menuPopover.closePopover();
        popoverMenuData.value = null;
    }

    if (!clickedInsidePopover && !e.target.closest(".profile-avatar") && !e.target.closest(".profile-area-trigger")) {
        profilePopover.closePopover();
    }
};

const toggleCollapse = () => {
    globalStore.toggleLeftNav();
    localStorage.setItem("sidebar-collapsed", JSON.stringify(isCollapsed.value));
    if (isCollapsed.value) {
        menuPopover.closePopover();
        popoverMenuData.value = null;
        profilePopover.closePopover();
        largeScreenPopoverOpen.value = false; // close large screen popover too
    }
};

const saveScrollPosition = () => {
    if (navRef.value) {
        localStorage.setItem("leftnav-scroll-position", navRef.value.scrollTop);
    }
};

const handleMenuClick = (menuItem, isSubMenu = false, event = null) => {
    // Prevent default anchor navigation to avoid race condition
    if (event) {
        event.preventDefault();
    }
    
    // Collapsed menu click to show popover (only on non‑large screens)
    if (isCollapsed.value && menuItem.submenu && !isSubMenu) {
        const isSameMenu = popoverMenuData.value?.menu === menuItem.menu;

        if (isSameMenu && menuPopover.isOpen.value) {
            menuPopover.closePopover();
            popoverMenuData.value = null;
            return;
        }

        profilePopover.closePopover();

        const sidebarRightEdge = sidebarRef.value
            ? sidebarRef.value.getBoundingClientRect().right
            : 80;

        popoverMenuData.value = menuItem;
        activeMenu.value = menuItem.menu;
        menuPopover.openPopover(event, sidebarRightEdge);
        return;
    }

    // Handle submenu click
    if (isSubMenu) {
        activeSubMenu.value = menuItem.menu;

        // Close large screen popover if open
        if (isLargeScreen.value && isCollapsed.value) {
            largeScreenPopoverOpen.value = false;
        }

        // Always close other popovers
        menuPopover.closePopover();
        profilePopover.closePopover();
        popoverMenuData.value = null;

        if (menuItem.link) {
            saveScrollPosition();
            window.location = menuItem.link;
        }
        return;
    }

    // Handle main menu click (normal)
    if (menuItem.submenu) {
        activeMenu.value = activeMenu.value === menuItem.menu ? "" : menuItem.menu;
        profilePopover.closePopover();
        return;
    }

    activeMenu.value = menuItem.menu;
    activeSubMenu.value = "";
    if (menuItem.link) {
        saveScrollPosition();
        window.location = menuItem.link;
    }
    showProfileSettings.value = false;
    profilePopover.closePopover();

    if (menuItem.menu === 'logout') {
        sessionStorage.clear();
    }
};


const toggleProfileSettings = (event) => {
    activeMenu.value = "profile";
    activeSubMenu.value = "";

    if (isCollapsed.value) {
        menuPopover.closePopover();
        popoverMenuData.value = null;
        activeMenu.value = '';

        if (profilePopover.isOpen.value) {
            profilePopover.closePopover();
        } else {
            const sidebarRightEdge = sidebarRef.value
                ? sidebarRef.value.getBoundingClientRect().right
                : 80;
            profilePopover.openPopover(event, sidebarRightEdge);
        }
        return;
    }

    showProfileSettings.value = !showProfileSettings.value;
    if (!showProfileSettings.value) {
        activeMenu.value = '';
    }
};

const handleActiveTab = (tab) => {
    activeTab.value = tab;
    handleMenuClick(
        tab === "internal"
            ? { menu: "internal", link: "/internal/dashboard" }
            : { menu: "external", link: "/dashboard" }
    );
};

const setActiveMenuFromUrl = () => {
    const { pathname, search } = window.location;

    const allowQueryRoutes = ["/supplier-promotions"];

    const shouldKeepQuery = allowQueryRoutes.some(route =>
        pathname.startsWith(route)
    );

    const url = shouldKeepQuery
        ? pathname + search
        : pathname;

    // Merge both filtered and original arrays to ensure all menus are checked for URL matching
    const allMenuItems = [...menuItems, ...toolMenuItems];
    for (const item of allMenuItems) {
        if (item.link && url.startsWith(item.link)) {
            activeMenu.value = item.menu;
            return;
        }
        const sub = item.submenu?.find(s => url.startsWith(s.link));
        if (sub) {
            activeSubMenu.value = sub.menu;
            activeMenu.value = item.menu;
            return;
        }
    }
};


const loadUserInfo = async() => {
    await userStore.getUserDetails();
};

const isMobile = ref(false)

// Check if user is internal staff using isLoginAs flag
// isLoginAs = true → INTERNAL STAFF (show all menu items including switch-account)
// isLoginAs = false → CUSTOMER (hide switch-account, but show change-password)
const isLoginAs = computed(() => window.appConfig?.isLoginAs);

const filteredUserProfile = computed(() => {
    return userProfile.filter(item => {
        // Hide ONLY switch-account for customer accounts
        // Customers can still see and use change-password
        if (!isLoginAs.value) {
            return item.menu !== "switch-account";
        }
        // Show all items for internal staff
        return true;
    });
});

const fullName = computed(() => `${firstName.value} ${lastName.value}`);
const initials = computed(() => (firstName.value[0] || "") + (lastName.value[0] || ""));
const internalUser = computed(() => userStore.userRoles?.includes("RoofHubInternal"));

onMounted(() => {
    window.addEventListener("resize", handleResize);

    document.addEventListener("click", closeAllPopovers);

    const saved = localStorage.getItem("sidebar-collapsed");
    if (saved !== null) {
        globalStore.setLeftNavCollapsed(JSON.parse(saved));
    }

    setActiveMenuFromUrl();
    loadUserInfo();

    if (window.innerWidth < 767) {
        isMobile.value = true;
        globalStore.toggleLeftNav()
    }

    window.addEventListener("popstate", setActiveMenuFromUrl);

    const pushState = history.pushState;
    history.pushState = function () {
        pushState.apply(history, arguments);
        setActiveMenuFromUrl();
    };

    checkNotificationHeader()

    window.addEventListener("scroll", handleScroll);

    // Restore scroll position
    const restoreScrollPosition = () => {
        const savedScrollPosition = localStorage.getItem("leftnav-scroll-position");
        if (savedScrollPosition !== null && navRef.value) {
            navRef.value.scrollTop = parseInt(savedScrollPosition, 10);
            localStorage.removeItem("leftnav-scroll-position");
        }
    };
    
    setTimeout(restoreScrollPosition, 500);
});

onUnmounted(() => {
    window.removeEventListener("resize", handleResize);
    document.removeEventListener("click", closeAllPopovers);
    window.removeEventListener("popstate", setActiveMenuFromUrl);
});


function handleScroll() { 
        menuPopover.closePopover();
        profilePopover.closePopover();
        popoverMenuData.value = null;
 }
function checkNotificationHeader() {
    const notificationHeader = document.querySelector(".global-notification");
    const sidebar = sidebarRef.value;

    if (!sidebar) return;

    const isMobile = windowWidth.value < 767;
    const is4k = windowHeight.value > 1200;

    if (notificationHeader && !isMobile && internalUser.value) {
        // If there's a notification and it's desktop and user is internal, we set it to 95vh to accomodate the notification without causing overflow
        sidebar.style.height = "95vh";
    } else if (notificationHeader && !isMobile && !is4k) {
        // If there's a notification and it's desktop and user is not internal, we set it to 95vh to accomodate the notification without causing overflow
        sidebar.style.height = "95vh";
    } else if(is4k) {
        // For 4k screens, we set it to auto to allow it to expand as needed, since 100vh can be too short on very large screens
        sidebar.style.height = "auto";
        sidebar.style.display = "block"; 
    } else{
        // In all other cases, we can safely set it to 100vh
        sidebar.style.height = "100vh";
    }
}


    const filteredMenuItems = computed(() => {
        // Check if this is a demo account (DEMO001) - check both config and window.appConfig
        const isDemo001Account = window.appConfig?.isDemo001Account;
        const isLoginAsUser = window.appConfig?.isLoginAs;

        return menuItems.filter(item => {

        // Check for feature flag restriction
        if (item.featureFlag) {
            if (config.value?.[item.featureFlag] !== true) {
                return false;
            }
        }

        // If showForDemo is true and this is a demo account, always show the item
        if (item.showForDemo === true && isDemo001Account === true) {
            return true;
        }

        // Check for login as restriction
        if (item.disallowLoginAs === true) {
            if (isLoginAsUser === true) {
                return false;
            }
        }

        // Check expected roles
        if (item.roles && item.roles.length > 0) {
            return item.roles.some(role => userStore.userRoles?.includes(role));
        }

        return true;
    })
    .map(item => ({
        ...item,
        submenu: item.submenu
            ? item.submenu.filter(sub => {
               
                // Check for feature flag restriction
                if (sub.featureFlag) {
                    if (config.value?.[sub.featureFlag] !== true) {
                        return false;
                    }
                }

                // If showForDemo is true and this is a demo account, always show the item
                if (sub.showForDemo === true && isDemo001Account === true) {
                    return true;
                }

                // Check for login as restriction
                if (sub.disallowLoginAs === true) {
                    if (isLoginAsUser === true) {
                        return false;
                    }
                }

                // Check expected roles
                if (sub.roles && sub.roles.length > 0) {
                    return sub.roles.some(role => userStore.userRoles?.includes(role));
                }

                return true;
            })
            : null
    }));
});

const filteredToolMenuItems = computed(() => {
  const isDemo001Account = window.appConfig?.isDemo001Account;
  const isLoginAsUser = window.appConfig?.isLoginAs;

  let items = toolMenuItems
    .filter(item => {
      // Check for leads menu feature flag
      if (item.menu === "lead") {
        if (!window.rhLeads) {
          return false;
        }
      }

      // If showForDemo is true and this is a demo account, always show the item
      if (item.showForDemo === true && isDemo001Account === true) {
        return true;
      }

      // Check for feature flag restriction
      if (item.featureFlag) {
        if (config.value?.[item.featureFlag] !== true) {
          return false;
        }
      }

      // Check for login as restriction
      if (item.disallowLoginAs === true) {
        if (isLoginAsUser === true) {
          return false;
        }
      }

      // Check expected roles
      if (item.roles?.length) {
        return item.roles.some(role => userStore.userRoles?.includes(role));
      }

      return true;
    })
    .map(item => ({
      ...item,
      submenu: item.submenu
        ? item.submenu.filter(sub => {
            // If showForDemo is true and this is a demo account, always show the item
            if (sub.showForDemo === true && isDemo001Account === true) {
              return true;
            }

            // Check for feature flag restriction
            if (sub.featureFlag) {
              if (config.value?.[sub.featureFlag] !== true) {
                return false;
              }
            }

            // Check for login as restriction
            if (sub.disallowLoginAs === true) {
              if (isLoginAsUser === true) {
                return false;
              }
            }

            // Check expected roles
            if (sub.roles?.length) {
              return sub.roles.some(role => userStore.userRoles?.includes(role));
            }

            return true;
          })
        : null,
    }));
  const weatherEnabled = config.value?.enableWeatherAlertsFeature === true;
  if (!weatherEnabled) {
    const reportsIndex = items.findIndex(i => i.menu === "reports");
    if (reportsIndex !== -1) {
      const reportsItem = items[reportsIndex];
      const propertyReport = reportsItem.submenu?.find(
        s => s.menu === "property-reports"
      );

      if (propertyReport) {
        // Replace reports with property reports as top-level
        items[reportsIndex] = {
          icon: "ri-file-list-3-line",
          selectedIcon: "ri-file-list-3-fill",
          name: propertyReport.name,
          menu: propertyReport.menu,
          link: propertyReport.link,
          submenu: null, // ensure no submenu remains
        };
      }
    }
  }

  return items;
});

watch(
    () => isCollapsed.value,
    collapsed => {
        if (isMobile.value) {
            if (collapsed) {
                document.body.classList.remove('overflow-hidden')
            } else {
                document.body.classList.add('overflow-hidden')
            }
        }
    }
)

const closeLeftNavOnOverlay = () => {
    if (!isCollapsed.value) {
        toggleCollapse();
    }
}
</script>
<style scoped>
 
 @media (min-height: 1200px) and (min-width: 2560px) {
    .nav-custom {
        display: block !important;
    }
}
 
/* Simple compact left navigation for print */
@media print {
    .left-nav {
        position: static !important;
        float: left !important;
        font-size: 12px !important;
    }

    /* Full width when expanded */
    .left-nav:not(.md\:w-\[80px\]) {
        width: 280px !important;
    }

    /* Collapsed width when collapsed */
    .left-nav.md\:w-\[80px\] {
        width: 80px !important;
    }
}
</style>